import { ReactNode, useRef } from 'react';
import styled from '@emotion/styled';
import { zIndex } from 'presentations/views/styles';
import Popper from '@mui/material/Popper';

interface Props {
  isOpen?: boolean;
  anchor?: any;
  children: ReactNode;
  className?: string;
  placement?: 'left' | 'right';
}

export default function Component(props: Props) {
  const arrowRef = useRef(null);
  const isOpen = props.isOpen ?? Boolean(props.anchor);
  const placement = props.placement ?? 'left';

  const modifier = [
    {
      name: 'flip',
      enabled: true,
      options: {},
    },
    {
      name: 'preventOverflow',
      enabled: true,
      options: {
        boundariesElement: 'viewport',
      },
    },
    {
      name: 'arrow',
      enabled: true,
      options: {
        element: arrowRef.current,
      },
    },
  ];

  return (
    <StyledPopper
      className={props.className}
      anchorEl={props.anchor}
      placement={placement}
      disablePortal={false}
      open={isOpen}
      modifiers={modifier}
    >
      <Arrow ref={arrowRef} className="MuiPopper-arrow" />
      {props.children}
    </StyledPopper>
  );
}

const StyledPopper = styled(Popper)`
  z-index: ${zIndex(1500)};
  & > div {
    position: relative;
  }
  &[data-popper-placement*='bottom'] {
    & > div {
      margin-top: 2px;
    }
    & .MuiPopper-arrow {
      top: 0;
      left: 0;
      margin-top: -0.9em;
      width: 3em;
      height: 1em;
      &::before {
        border-width: 0 1em 1em 1em;
      }
    }
  }
  &[data-popper-placement*='right'] {
    & > div {
      margin-left: 8px;
    }
    & .MuiPopper-arrow {
      left: 8px;
      margin-left: -0.9em;
      height: 3em;
      width: 1em;
      &::before {
        border-width: 1em 1em 1em 0;
        border-color: transparent white transparent transparent;
      }
    }
  }
  &[data-popper-placement*='left'] {
    & > div {
      margin-right: 8px;
    }
    & .MuiPopper-arrow {
      right: 8px;
      margin-right: -0.9em;
      height: 3em;
      width: 1em;
      &::before {
        border-width: 1em 0 1em 1em;
        border-color: transparent transparent transparent white;
      }
    }
  }
`;

const Arrow = styled.div`
  position: absolute;
  font-size: 7px;
  width: 3em;
  height: 3em;
  &::before {
    content: '';
    margin: auto;
    display: block;
    width: 0;
    height: 0;
    border-style: solid;
  }
`;
